import React from 'react';
import { KibSnackbarManager, KibSnackbar } from '@chewy/kib-messaging-react';

type VetActionableSnackbarProps = {
  visible: boolean;
  actionMessage: string;
  buttonText: string;
  onClick: (...args: []) => void;
  onClose: (...args: []) => void;
};

const VetActionableSnackbar = ({
  visible,
  actionMessage,
  buttonText,
  onClick,
  onClose,
}: VetActionableSnackbarProps) => (
  <KibSnackbarManager offset={24} visible={visible} onClose={onClose}>
    <KibSnackbar
      action={(actionClass) => (
        <button
          data-testid="pet-form-vet-snackbar-button"
          className={actionClass}
          onClick={onClick}
        >
          {buttonText}
        </button>
      )}
    >
      {actionMessage}
    </KibSnackbar>
  </KibSnackbarManager>
);

export default VetActionableSnackbar;
